// FailureAlert.js
import React from "react";
import { Box, Card, CardContent, Typography, Button } from "@mui/material";
import CancelIcon from "@mui/icons-material/Cancel";

const FailureAlert = ({
  message = "Something went wrong!",
  onClose,
}) => {
  return (
    <Box
      sx={{
        position: "fixed",
        inset: 0,
        backgroundColor: "rgba(0,0,0,0.4)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9999,
        padding: 2,
      }}
      onClick={onClose} // Optional: click outside to close
    >
      <Card
        sx={{
          width: "100%",
          maxWidth: 320,
          borderRadius: 4,
          textAlign: "center",
          padding: 3,
        }}
        elevation={8}
        onClick={(e) => e.stopPropagation()} // Prevent closing when clicking inside
      >
        <CardContent>
          <CancelIcon
            sx={{
              fontSize: 70,
              color: "error.main",
              mb: 2,
            }}
          />

          <Typography variant="h6" fontWeight="bold" gutterBottom>
            Failed
          </Typography>

          <Typography variant="body2" color="text.secondary" mb={3}>
            {message}
          </Typography>

          <Button
            variant="contained"
            color="error"
            fullWidth
            onClick={() => {
              console.log("Done button clicked"); // Add debug log
              if (onClose) {
                onClose();
              }
            }}
            sx={{
              borderRadius: 3,
              paddingY: 1,
              fontWeight: 600,
            }}
          >
            Done
          </Button>
        </CardContent>
      </Card>
    </Box>
  );
};

export default FailureAlert;